import styled, { keyframes } from "styled-components";

const pulse = keyframes`
    0%{
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(127, 191, 208, .45);
    }

    70%{
        transform: scale(1.05);
        box-shadow: 0 0 0 18px rgba(127, 191, 208, 0);
    }

    100%{
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(127, 191, 208, 0);
    }
`;

export const BackToTopButton = styled.button`
    position: fixed;

    right: 2rem;
    bottom: 7rem;

    width: 56px;
    height: 56px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: none;
    border-radius: 50%;

    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.background};
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
    transform: ${({ $visible }) => $visible ? "translateY(0)" : "translateY(15px)"};
    pointer-events: ${({ $visible }) => $visible ? "auto" : "none"};

    cursor: pointer;

    z-index: 999;

    box-shadow: 0 15px 35px rgba(0,0,0,.25);

    transition:
        opacity .3s ease,
        transform .3s ease,
        visibility .3s ease,
        box-shadow .3s ease;

    &:hover {
        transform: translateY(-4px);

        box-shadow: 0 20px 45px rgba(127, 191, 208, .35);
    }

    @media (max-width: 768px) {
        width: 50px;
        height: 50px;

        right: 1.5rem;
        bottom: 1.5rem;
    }
`;

export const WhatsAppButton = styled.a`
    position: fixed;

    right: 2rem;
    bottom: 12rem;

    width: 56px;
    height: 56px;

    display: flex;
    justify-content: center;
    align-items: center;

    border: none;
    border-radius: 50%;

    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.background};

    animation: ${pulse} 2.5s infinite;

    text-decoration: none;

    cursor: pointer;

    box-shadow: 0 10px 25px rgba(37, 211, 102, .35);

    opacity: ${({$visible}) => ($visible ? 1 : 0)};
    visibility: ${({$visible}) => ($visible ? "visible" : "hidden")};
    pointer-events: ${({$visible}) => ($visible ? "auto" : "none")};

    transform: ${({ $visible }) =>
        $visible ? "translateY(0)" : "translateY(20px)"};

    transition: all .3s ease;

    z-index: 999;

    &:hover {
        transform: translateY(-4px) scale(1.08);

        animation-play-state: paused;

        box-shadow: 0 18px 40px rgba(127, 191, 208, .35);
    }

    @media (max-width: 768px) {
        width: 50px;
        height: 50px;

        right: 1.5rem;
        bottom: 5.5rem;
    }
`;